import React, { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { 
  ProgramDropdown,
  BrandDropdown,
  BussinesModelDropdown,
  GeographiesDropdown,
  LanguagesDropdown
} from "CommonDropdowns";
import moment from 'moment-timezone';

const Filter = ({ onFilter, extraFiltersState, setExtraFiltersState }) => {
  // No dropdown, so no show state needed
  const [refreshing, setRefreshing] = useState(false);
  const [programValue, setProgramValue] = useState(null);
  const [brandValue, setBrandValue] = useState(null);
  const [languageValue, setLanguageValue] = useState(null);
  const [businessModelValue, setBusinessModelValue] = useState(null);
  const [geographyValue, setGeographyValue] = useState(null);
  


  const handleSearch = () => {
    onFilter();
  };

  const handleReset = () => {
    setExtraFiltersState({
      ...extraFiltersState,
      values: {
        year: "",
        month: "",
        program_id: null,
        brand_ids: null,
        language_ids: null,
        business_model_ids: null,
        geography_ids: null,
        selectedDate: null,
        formatDate: "",
      },
    });
    setProgramValue(null);
    setBrandValue(null);
    setLanguageValue(null);
    setBusinessModelValue(null);
    setGeographyValue(null);
    onFilter();
  };

  const handleInputChange = (name, value) => {
    setExtraFiltersState((extraFiltersState) => ({
      ...extraFiltersState,
      values: {
        ...extraFiltersState.values,
        [name]: value,
      },
    }));
  };

  const handleDateChange = (date) => {  
    if (!date) {
      setExtraFiltersState((extraFiltersState) => ({
        ...extraFiltersState,
        values: {
          ...extraFiltersState.values,
          year: "",
          month: "",
          program_id: null,
          brand_ids: null,
          language_ids: null,
          business_model_ids: null,
          geography_ids: null,
          selectedDate: null,
          formatDate: "",
        },
      }));
      setProgramValue(null);
      setBrandValue(null);
      setLanguageValue(null);
      setBusinessModelValue(null);
      setGeographyValue(null);
    } else {
      let formatDate = moment(date).format("YYYY-MM");
      setExtraFiltersState((extraFiltersState) => ({
        ...extraFiltersState,
        values: {
          ...extraFiltersState.values,
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          formatDate: formatDate,
          selectedDate: date,
        },
      }));
    }
  };

  
  const handleProgramChange = (selected) => {
    setProgramValue(selected);
    const programId = selected ? selected.map((item) => item.value) : null;
    handleInputChange("program_id", programId);
    // Reset brand when program changes
    setBrandValue(null);
    handleInputChange("brand_ids", null);
  };

  const handleBrandChange = (selected) => {
    setBrandValue(selected);
    const brandId = selected ? selected.map((item) => item.value) : null;
    handleInputChange("brand_ids", brandId);
  };

  const handleLanguageChange = (selected) => {
    setLanguageValue(selected);
    const languageId = selected ? selected.map((item) => item.value) : null;
    handleInputChange("language_ids", languageId);
  };

  const handleBusinessModelChange = (selected) => {
    setBusinessModelValue(selected);
    const businessModelId = selected
      ? selected.map((item) => item.value)
      : null;
    handleInputChange("business_model_ids", businessModelId);
  };

  const handleGeographyChange = (selected) => {
    setGeographyValue(selected);
    const geographyId = selected ? selected.map((item) => item.value) : null;
    handleInputChange("geography_ids", geographyId);
  };

  return (
    <div className="filters-flex">
      <Form>
        <Row className="align-items-end g-3">
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Period</Form.Label>
              <DatePicker
                selected={extraFiltersState.values.selectedDate}
                onChange={handleDateChange}
                dateFormat="yyyy-MM"
                showMonthYearPicker
                className="input-field w-100 px-2"
                placeholderText="Choose Period"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <ProgramDropdown
                programValue={programValue}
                setProgramValue={setProgramValue}
                programOnChange={handleProgramChange}
                isMulti={true}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <BrandDropdown
                value={brandValue}
                setValue={setBrandValue}
                onChange={handleBrandChange}
                isMulti={true}
                program_id={extraFiltersState.values.program_id}
                selectedId={extraFiltersState.values.brand_ids}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <LanguagesDropdown
                value={languageValue}
                setValue={setLanguageValue}
                onChange={handleLanguageChange}
                isMulti={true}
                selectedId={extraFiltersState.values.language_ids}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <BussinesModelDropdown
                value={businessModelValue}
                setValue={setBusinessModelValue}
                onChange={handleBusinessModelChange}
                isMulti={true}
                selectedId={extraFiltersState.values.business_model_ids}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <GeographiesDropdown
                value={geographyValue}
                setValue={setGeographyValue}
                onChange={handleGeographyChange}
                isMulti={true}
                selectedId={extraFiltersState.values.geography_ids}
              />
            </Form.Group>
          </Col>
          <Col>
            <div className="d-flex align-items-center gap-2">
              <button
                type="button"
                onClick={handleSearch}
                className="add-new-btn w-100 mb-3"
              >
                <img src="/assets/images/search-white.svg" alt="" className="me-2" />
              </button>
              <button
                type="button"
                className="refresh-btn"
                onClick={() => {
                  setRefreshing(true);
                  handleReset();
                  setTimeout(() => setRefreshing(false), 400);
                }}
              >
                <img
                  src="/assets/images/refresh-icon.svg"
                  alt=""
                  className={refreshing ? 'rotate' : ''}
                />
              </button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Filter;
